import { Pipe, PipeTransform } from '@angular/core';
import { SDOHActionPlan } from '../models/sdoh-action-plan';

@Pipe({ name: 'inProgressSDOHActionStepCount' })
export class InProgressSDOHActionStepCount implements PipeTransform {
  transform(actionPlan: SDOHActionPlan): number {
    return actionPlan.sdohActionSteps?.filter((actionStep) => actionStep.status === 'In Progress').length;
  }
}
